import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthResponse } from '../../../core/models/auth.model';
import { HttpService } from '../../../core/services/http.service';
import { LoggingService } from '../../../core/services/logging.service';

/**
 * AuthorizationService
 *
 * PPN authorization used in UAT and production: the PPN/ALB layer authenticates the
 * user and the backend returns the token and profile for the PPN identity.
 *
 * API: `GET /users/authorize`
 */
@Injectable({ providedIn: 'root' })
export class AuthorizationService extends HttpService {
  private readonly logger = inject(LoggingService);

  /**
   * Validates the PPN session and retrieves the application token and user.
   *
   * @returns Observable of the token and user profile (with role permissions).
   */
  authorize(): Observable<AuthResponse> {
    this.logger.debug('AuthorizationService.authorize: calling /users/authorize');
    return this.getData<AuthResponse>('/users/authorize');
  }
}
